module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "mb-5"
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n    Form Submissions\n    "), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('share-form', {
    attrs: {
      "relationship-id": _vm.relationshipId
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": "",
      "loading": _vm.request.loading
    },
    on: {
      "click": _vm.getSubmissions
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1)], 1), _vm._v(" "), [_c('v-list', {
    staticClass: "pa-0 elevation-0 my-4",
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.submissions), function(submission) {
    return [_c('v-list-tile', {
      key: submission.submission_id,
      on: {
        "click": function($event) {
          _vm.selectedSubmission = submission;
          _vm.submissiondetaildialog = true
        }
      }
    }, [_c('v-list-tile-content', [(submission.form) ? _c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(submission.form.title)
      }
    }) : _c('v-list-tile-title', [_c('v-icon', {
      attrs: {
        "small": "",
        "color": "info"
      }
    }, [_vm._v("info")]), _vm._v("\n            Form is no longer linked, or no longer exists\n          ")], 1), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n            Submitted: " + _vm._s(_vm.dateformat(submission.created_date)) + "\n          ")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "flat": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.confirmSync = true
        }
      }
    }, [_vm._v("Re-Sync")])], 1), _vm._v(" "), _c('v-dialog', {
      attrs: {
        "width": "450"
      },
      model: {
        value: (_vm.confirmSync),
        callback: function($$v) {
          _vm.confirmSync = $$v
        },
        expression: "confirmSync"
      }
    }, [_c('request-status', {
      attrs: {
        "request": _vm.syncRequest,
        "message200": false
      },
      on: {
        "ok": function($event) {
          _vm.confirmSync = false
        }
      }
    }), _vm._v(" "), _c('v-card', [_c('v-card-title', {
      staticClass: "subtitle-1 overline"
    }, [_vm._v("\n              Sync this submission to AppointmentGuru client\n              "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          _vm.confirmSync = false
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('p', [_vm._v("This will sync the data from the form submission with their AppointmentGuru client information\n              such as their contact information and medical aid information.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Note")]), _vm._v(" Normally you should not need to perform this step manually as\n              the information is typically automatically synced when the submission is received")])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      attrs: {
        "flat": ""
      },
      on: {
        "click": function($event) {
          _vm.confirmSync = false
        }
      }
    }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "color": "primary",
        "loading": _vm.syncRequest.loading
      },
      on: {
        "click": function($event) {
          return _vm.sync(submission)
        }
      }
    }, [_vm._v("Sync")])], 1)], 1)], 1), _vm._v(" "), (submission.submission_id && submission.form && submission.form.form_id) ? _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "href": ("https://jotform.com/inbox/" + (submission.form.form_id) + "/" + (submission.submission_id)),
        "target": "_blank",
        "icon": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.noop.apply(null, arguments)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("open_in_new")])], 1)], 1) : _vm._e()], 1)]
  }), _vm._v(" "), (_vm.submissions && _vm.submissions.length === 0) ? _c('v-list-tile', {
    staticClass: "mb-5"
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("No linked submissions found.\n          ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "460"
    },
    model: {
      value: (_vm.showSubmissionPicker),
      callback: function($$v) {
        _vm.showSubmissionPicker = $$v
      },
      expression: "showSubmissionPicker"
    }
  }, [_c('assign-submission', {
    attrs: {
      "relationship-id": _vm.relationshipId
    },
    on: {
      "close": function($event) {
        _vm.showSubmissionPicker = false
      },
      "ok": _vm.getSubmissions
    }
  }, [_c('v-card-actions', {
    attrs: {
      "slot": "card-actions"
    },
    slot: "card-actions"
  }, [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showSubmissionPicker = false
      }
    }
  }, [_vm._v("Cancel ")])], 1)], 1)], 1)], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/integrations/jotform",
      "flat": ""
    }
  }, [_c('v-icon', {
    staticClass: "mr-1"
  }, [_vm._v("search")]), _vm._v("\n        Find a submission\n      ")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/integrations/jotform",
      "flat": ""
    }
  }, [_vm._v("Manage integration")])], 1)], _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.submissiondetaildialog),
      callback: function($$v) {
        _vm.submissiondetaildialog = $$v
      },
      expression: "submissiondetaildialog"
    }
  }, [(_vm.selectedSubmission) ? _c('form-submission-card', {
    key: _vm.selectedSubmission.submission_id,
    attrs: {
      "with-close": "",
      "submission-id": _vm.selectedSubmission.submission_id
    },
    on: {
      "close": function($event) {
        _vm.submissiondetaildialog = false
      }
    }
  }) : _vm._e()], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fa1d85f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/medicalaid/ClientForms.vue
// module id = 1421
// module chunks = 9